export default {
	es: {
		enlaces : {
			politica_privacidad : "/politica-de-privacidad",
			politica_cookies : "/politica-de-cookies",
			login : "/login",
			solicitar_cuenta : "/solicitar-cuenta",
			registroalumno : "/registro",
			encuestas : '/encuestas',
			encuesta : '/encuesta',
			eventos : '/eventos',
			eventospublico : '/evento-publico',
			documentacion : '/documentacion',
			guiaOrientacion : '/guias-orientacion',
			ofertas_practicas : '/ofertas-practicas',
			ofertas_empleo : '/ofertas-empleo',
			cv : '/cv',
			vercv : '/ver-cv',
			mis_candidaturas : '/mis-candidaturas',
			mis_practicas : '/mis-practicas',
			orientacion : '/orientacion-laboral',
			propuesta_practicas : '/propuesta-practicas',
			programapracticasactivos : '/programas-practicas-activos',
			solicitarcambiopracticas : '/solicitar-cambio-practicas',
			subirconvenio : '/subir-convenio-firmado',
			generarnuevoconvenio : '/nuevo-convenio-colaboracion',
			practicaseducacion : '/solicitudes-practicas-educacion',
			nueva_oferta : '/nueva-oferta',
			editar_oferta : '/editar-oferta',
			mi_empresa : '/mi-empresa',
			mi_perfil : '/mi-perfil',
			mis_ofertas : '/mis-ofertas',
			mi_oferta : '/oferta',
			programa_practicas : '/programa-practicas',
			visualizar_oferta : '/visor-oferta',
			restablecer_login : '/restablecer-login',
			restablecer_candidato : '/restablecer-candidato',
			setear_pass : '/establecer-login',
			proteccion_datos : '/proteccion-de-datos',
			acceso_saml  : '/acceso',
			logout  : '/logout',
			ayuda  : '/ayuda',
		},
		encabezado : {
			home : 'Bienvenid@',
			cv : 'Mi currículum',
			cv_view : 'Currículum del candidato',
			eventos : 'Eventos',
			propuesta_practicas : "Propuesta de prácticas",
			politica_privacidad : "Política de privacidad",
			politica_cookies : "Política de cookies",
			login : "Inicio de sesión",
			solicitar_cuenta : "Nueva empresa",
			registro_alumno : "Registro",
			ofertas_practicas : 'Listado de ofertas de prácticas',
			ofertas_empleo : 'Listado de ofertas de empleo',
			ficha_oferta_alumno_empleo : 'Listado de ofertas de empleo',
			ficha_oferta_alumno_practicas : 'Listado de ofertas de prácticas',
			mis_candidaturas : 'Mis candidaturas',
			mis_practicas : 'Mis prácticas',
			encuestas : 'Encuestas',
			orientacion : 'Orientación laboral',
			nueva_oferta : 'Nueva oferta',
			editar_oferta : 'Editar oferta',
			mi_empresa : "Mi empresa",
			mi_perfil : "Mi perfil",
			documentacion : 'Documentación',
			guiasOrientacion : 'Guías Orientación',
			documentacion_empresa : 'Documentación',
			documentacion_alumno : 'Mi documentación',
			mis_ofertas : 'Mis ofertas',
			mi_oferta : 'Mi oferta',
			ficha_oferta_empresa : 'Mi oferta',
			restablecer_login : 'Restablecer Contraseña',
			restablecer_candidato : 'Restablecer Contraseña',
			programapracticasactivos : 'Programas de prácticas activos',
			setear_pass : 'Establecer Contraseña',
			proteccion_datos : 'Protección de datos',
			visor_oferta : "Ver como alumno",
			fichaProgramaActivo : "Programas activos",
			solicitudCambioPracticas : "Solicitud cambio de prácticas",
			solicitudesEducacion : "Solicitudes ofertas educación",
			subirConvenioFirmado : 'Subir convenio firmado',		
			generarNuevoConvenio : 'Nuevo convenio de Colaboración',
			ayuda : 'Ayuda'		
		},
		ficha_oferta : {
			texto_programa_anadido : "Tienes este programa añadido a tu lista de programas informáticos"
		},
		formulario : {
			nombre : "Nombre",
			nombre_apellidos : "Nombre y apellidos",
			apellidos : "Apellidos",
			email : "Email",
			mensaje : "Mensaje",
			fecha_nacimiento : "Fecha de nacimiento",
			dia : "Día",
			mes : "Mes",
			anyo : "Año",
			area_interes : "Área de su interés",
			trabaja_actualmente : "¿Trabaja actualmente?",
			si : "Si",
			no : "No",
			carta_presentacion : "Carta de presentacion",
			meses : {
				Enero : "Enero",
				Febrero : "Febrero",
				Marzo : "Marzo",
				Abril : "Abril",
				Mayo : "Mayo",
				Junio : "Junio",
				Julio : "Julio",
				Agosto : "Agosto",
				Septiembre : "Septiembre",
				Octubre : "Octubre",
				Noviembre : "Noviembre",
				Diciembre : "Diciembre"
			},
			archivo_adjunto : "Adjuntar archivo",
			adjuntar_cv : "Adjuntar CV",
			introduce_mail : "Introduce tu email",
			pais : "País",
			telefono : "Teléfono",
			he_leido : "He leído y acepto la",
			y_acepto : "política de privacidad",
			enviar : "Enviar",
			enviado : "Enviado",
		},
		meses : ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],

	},
	en: {
		enlaces : {
			actualidad : '/news',
			sala_de_prensa : "/press-room",
			contacto : "/contact",
			trabaja_con_nosotros: "/work-with-us",
			politica_privacidad : "/privacy-policy",
			politica_cookies : "/cookies-policy",
		}
	}
}



// WEBPACK FOOTER //
// ./src/translations/index.js